export const holidayCarnaval = [
	{
		city: "Salvador",
		city_code: "SSA",
		text: "Carnaval em Salvador com passagem aérea promocional é a sua melhor notícia. Vem ver.",
		img: "SSA"
	},
	{
		city: "Rio de Janeiro",
		city_code: "RIO",
		text:
			"Encontre voos baratos para passar o carnaval no Rio de Janeiro, um dos melhores do país.",
		img: "RIO"
	},
	{
		city: "Ouro Preto",
		city_code: "BHZ",
		text:
			"A poucas horas de Belo Horizonte, Ouro Preto traz o carnaval universitário que você pediu.",
		img: "OP"
	},
	{
		city: "Recife",
		city_code: "REC",
		text: "A melhor dica de carnaval em Recife é encontrar passagens aéreas promocionais.",
		img: "REC"
	},
	{
		city: "Fortaleza",
		city_code: "FOR",
		text: "A programação do carnaval em Fortaleza começa pelas passagens aéreas baratas.",
		img: "FOR"
	},
	{
		city: "São Paulo",
		city_code: "SAO",
		text: "Passe o carnaval em São Paulo economizando na passagem aérea. Aproveite.",
		img: "SAO"
	},
	{
		city: "Belo Horizonte",
		city_code: "BHZ",
		text: "O carnaval de rua em Belo Horizonte colocou a cidade como o destino da folia.",
		img: "BHZ"
	},
	{
		city: "Brasília",
		city_code: "BSB",
		text: "Passagens aéreas promocionais para Brasília no feriado de carnaval é aqui.",
		img: "BSB"
	},
	{
		city: "Gramado",
		city_code: "POA",
		text: "Destino romântico para carnaval? Gramado, a poucas horas de Porto Alegre, é pra você.",
		img: "GR"
	}
];
export const holidayAnoNovo = [
	{
		city: "Curitiba",
		city_code: "CWB",
		text: "Passar o ano novo em Curitiba é a certeza de se divertir com tranquilidade. Aproveite. ",
		img: "CWB"
	},
	{
		city: "Gramado",
		city_code: "POA",
		text: "Na Serra Gaúcha e a poucas horas de Porto Alegre, Gramado traduz o ano novo romântico. ",
		img: "GR"
	},
	{
		city: "Brasília",
		city_code: "BSB",
		text:
			"O ano novo em Brasília tem festas para todos os estilos. Aproveite os preços promocionais. ",
		img: "BSB"
	},
	{
		city: "Fortaleza",
		city_code: "FOR",
		text: "Para curtir a virada na praia, Fortaleza tem uma programação exclusiva para ano novo. ",
		img: "FOR"
	},
	{
		city: "Búzios",
		city_code: "RIO",
		text: "A poucas horas do Rio de Janeiro, Búzios tem um calendário de festas de ano novo. ",
		img: "BU"
	},
	{
		city: "Rio de Janeiro",
		city_code: "RIO",
		text: "Para viver o show dos fogos de Copacabana, aproveite as passagens promocionais. ",
		img: "RIO"
	},
	{
		city: "Porto Alegre",
		city_code: "POA",
		text: "A programação de ano novo em Porto Alegre começa com voos baratos. Confira. ",
		img: "POA"
	},
	{
		city: "Porto Seguro",
		city_code: "BPS",
		text: "Das praias às festas, a virada do ano em Porto Seguro é a garantia de diversão. ",
		img: "BPS"
	},
	{
		city: "São Paulo",
		city_code: "SAO",
		text: "A programação de ano novo em São Paulo foge do convencional e vai te surpreender. ",
		img: "SAO"
	}
];
export const holidayDiaDasMaes = [
	{
		city: "Brasília",
		city_code: "BSB",
		text: "Encontre passagens aéreas promocionais para Dia Das Mães em Brasília.",
		img: "BSB"
	},
	{
		city: "Manaus",
		city_code: "MAO",
		text: "Seja para rever a família ou conhecer Manaus, você precisará de passagens baratas.",
		img: "MAO"
	},
	{
		city: "Salvador",
		city_code: "SSA",
		text: "Dê um presente inesquecível no Dia das Mães: viaje para Salvador e surpreenda.",
		img: "SSA"
	},
	{
		city: "Belém",
		city_code: "BEL",
		text: "Viajar para Belém no Dia das Mães com economia é possível e basta um clique.",
		img: "BEL"
	},
	{
		city: "Curitiba",
		city_code: "CWB",
		text:
			"Curitiba é um ótimo destino para viajar em família. Já pensou em levar sua mãe para o Sul?",
		img: "CWB"
	},
	{
		city: "Foz do Iguaçu",
		city_code: "IGU",
		text: "Que tal dar uma viagem para Foz do Iguaçu de presente de Dia das Mães?",
		img: "IGU"
	},
	{
		city: "Teresina",
		city_code: "THE",
		text: "Encontre passagens baratas para Teresina e curta o Dia das Mães em família.",
		img: "THE"
	},
	{
		city: "Natal",
		city_code: "NAT",
		text: "O melhor presente do dia das mães é estar presente. O segundo é uma viagem para Natal.",
		img: "NAT"
	},
	{
		city: "Fortaleza",
		city_code: "FOR",
		text: "Economize no presente de dia das mãe com voos baratos para Fortaleza.",
		img: "FOR"
	}
];
export const holidayDiaDoTrabalho = [
	{
		city: "Curitiba",
		city_code: "CWB",
		text: "Encontre passagens aéreas promocionais para Curitiba no feriado do Dia do Trabalho.",
		img: "CWB"
	},
	{
		city: "Rio de Janeiro",
		city_code: "RIO",
		text: "Para passar o feriado do Trabalho no Rio de Janeiro, você não precisa gastar muito. ",
		img: "RIO"
	},
	{
		city: "Recife",
		city_code: "REC",
		text: "A dica para viajar no feriado do Trabalho para Recife é: economizar na passagem. ",
		img: "REC"
	},
	{
		city: "Goiânia",
		city_code: "GYN",
		text: "Viajar para Goiânia no feriado do Dia do Trabalho? Aqui, tem passagem econômica.  ",
		img: "GYN"
	},
	{
		city: "Campinas",
		city_code: "VCP",
		text: "Economize na sua passagem para Campinas e viaje no feriado do Dia do Trabalho.  ",
		img: "VCP"
	},
	{
		city: "Florianópolis",
		city_code: "FLN",
		text: "Aproveite o feriado do Dia do Trabalho e programe sua viagem econômica para Floripa. ",
		img: "FLN"
	},
	{
		city: "Belo Horizonte",
		city_code: "BHZ",
		text: "Buscando voos baratos para Belo Horizonte? Encontre sua passagem com desconto. ",
		img: "BHZ"
	},
	{
		city: "Vitória",
		city_code: "VIX",
		text:
			"Viajar para praia sem gastar muita grana no feriadão é fácil com voos baratos para Vitória. ",
		img: "VIX"
	},
	{
		city: "Fortaleza",
		city_code: "FOR",
		text: "Aproveite o feriadão e prepare sua viagem econômica para Fortaleza. ",
		img: "FOR"
	}
];
export const holidayDiaDosNamorados = [
	{
		city: "Gramado",
		city_code: "POA",
		text: "Viaje com economia para Gramado, um dos destinos mais românticos do país. ",
		img: "GR"
	},
	{
		city: "Fernando de Noronha",
		city_code: "FEN",
		text: "Encontre promoção de passagens para Fernando de Noronha no Dia dos Namorados.   ",
		img: "FEN"
	},
	{
		city: "Natal",
		city_code: "NAT",
		text:
			"Natal é um dos melhores destinos para viajar a dois e, com voos baratos, fica ainda melhor. ",
		img: "NAT"
	},
	{
		city: "Búzios",
		city_code: "RIO",
		text:
			"A poucas horas do Rio de Janeiro, Búzios traz o clima perfeito para uma viagem romântica. ",
		img: "BU"
	},
	{
		city: "Paraty",
		city_code: "RIO",
		text: "Com passagens aéreas promocionais para Rio de Janeiro, viaje com seu amor para Paraty.",
		img: "PA"
	},
	{
		city: "Rio de Janeiro",
		city_code: "RIO",
		text: "Economize na viagem para Dia dos Namorados com voos baratos para Rio de Janeiro. ",
		img: "RIO"
	},
	{
		city: "Jalapão",
		city_code: "PMW",
		text: "Como chegar ao Jalapão? A poucas horas de Palmas, o lugar é perfeito para vocês. ",
		img: "JA"
	},
	{
		city: "Bonito",
		city_code: "BYO",
		text: "No Dia dos Namorados, faça uma viagem romântica sem gastar muito para Bonito.",
		img: "BYO"
	},
	{
		city: "Salvador",
		city_code: "SSA",
		text: "Curta com seu amor uma viagem de Dia dos Namorados na Bahia.",
		img: "SSA"
	}
];
export const holidayFestaJunina = [
	{
		city: "Caruaru",
		city_code: "REC",
		text: "Aproveite os voos promocionais para Recife e viva a maior festa de São João do país. ",
		img: "CA"
	},
	{
		city: "Salvador",
		city_code: "SSA",
		text: "Aqui tem passagens aéreas promocionais para Salvador no período das Festas Juninas. ",
		img: "SSA"
	},
	{
		city: "Aracajú",
		city_code: "AJU",
		text: "Voos baratos para você aproveitar a programação das Festas Juninas em Aracajú. ",
		img: "AJU"
	},
	{
		city: "Fortaleza",
		city_code: "FOR",
		text: "Em Fortaleza, a Festa de São João começa com passagens aéreas baratas. ",
		img: "FOR"
	},
	{
		city: "João Pessoa",
		city_code: "JPA",
		text: "A programação da Festa Junina em João Pessoa está imperdível. Aproveite. ",
		img: "JPA"
	},
	{
		city: "Maceió",
		city_code: "MCZ",
		text: "Pela MaxMilhas, você encontra voos baratos para Maceió no período da Festa Junina. ",
		img: "MCZ"
	},
	{
		city: "São Paulo",
		city_code: "SAO",
		text: "Viaje com desconto e curta a programação de Festa Junina de São Paulo.",
		img: "SAO"
	},
	{
		city: "Rio de Janeiro",
		city_code: "RIO",
		text: "Economize com voos baratos para Rio de Janeiro no período das Festas de São João. ",
		img: "RIO"
	},
	{
		city: "Natal",
		city_code: "NAT",
		text: "Encontre voos baratos para Natal e aproveite a Festa Junina da cidade. ",
		img: "NAT"
	}
];
export const holidayIndependenciaDoBrasil = [
	{
		city: "Fortaleza",
		city_code: "FOR",
		text: "Viaje para Fortaleza com economia e aproveite o feriado da Independência. ",
		img: "FOR"
	},
	{
		city: "São Paulo",
		city_code: "SAO",
		text: "Voos baratos para São Paulo no feriadão é na MaxMilhas. ",
		img: "SAO"
	},
	{
		city: "Salvador",
		city_code: "SSA",
		text: "Compre passagens aéreas promocionais e curta o feriado em Salvador. ",
		img: "SSA"
	},
	{
		city: "Recife",
		city_code: "REC",
		text: "Voe com economia para Recife no feriado da Independência do Brasil 2018. ",
		img: "REC"
	},
	{
		city: "Curitiba",
		city_code: "CWB",
		text: "Encontre passagens aéreas promocionais para Curitiba no feriadão. ",
		img: "CWB"
	},
	{
		city: "Goiânia",
		city_code: "GYN",
		text: "Voos para Goiânia com desconto para você curtir o feriado da independência. ",
		img: "GYN"
	},
	{
		city: "São Luiz",
		city_code: "SLZ",
		text: "Aproveite o feriadão da Independência e viaje para São Luiz com desconto. ",
		img: "SLZ"
	},
	{
		city: "Florianópolis",
		city_code: "FLN",
		text: "Saiba o que fazer no feriado da Independência em Florianópolis e veja voos baratos. ",
		img: "FLN"
	},
	{
		city: "Porto Alegre",
		city_code: "POA",
		text: "Viaje no feriado da Independência do Brasil para Porto Alegre com até 80% de desconto.",
		img: "POA"
	}
];
export const holidayNossaSenhora = [
	{
		city: "Aparecida do Norte ",
		city_code: "SAO",
		text: "Encontre voos baratos para São Paulo e viaje para Aparecida do Norte no feriado. ",
		img: "NO"
	},
	{
		city: "Aparecida de Goiania",
		city_code: "GYN",
		text: "A poucas horas de Goiânia, viva a programação do Feriado de Nossa Senhora na cidade. ",
		img: "GO"
	},
	{
		city: "Fortaleza",
		city_code: "FOR",
		text: "Aproveite o feriado de Nossa Senhora Aparecida e viaje para Fortaleza com economia. ",
		img: "FOR"
	},
	{
		city: "São Paulo",
		city_code: "SAO",
		text: "Na MaxMilhas, você encontra passagens aéreas promocionais para São Paulo. ",
		img: "SAO"
	},
	{
		city: "Goiânia",
		city_code: "GYN",
		text: "Aproveite a programação do Feriado de Nossa Senhora Aparecida com voos promocionais. ",
		img: "GYN"
	},
	{
		city: "Belo Horizonte",
		city_code: "BHZ",
		text: "Voe para Belo Horizonte e conheça as cidades históricas no Feriado de Nossa Senhora. ",
		img: "BHZ"
	},
	{
		city: "Rio de Janeiro",
		city_code: "RIO",
		text: "Encontre voos promocionais para Rio de Janeiro no Feriado de Nossa Senhora.",
		img: "RIO"
	},
	{
		city: "Curitiba",
		city_code: "CWB",
		text: "Passagens aéreas promocionais para Curitiba no Feriado de Nossa Senhora é aqui.",
		img: "CWB"
	},
	{
		city: "Porto Alegre",
		city_code: "POA",
		text: "Viaje para Porto Alegre com economia no período do Feriado de Nossa Senhora.",
		img: "POA"
	}
];
export const holidayProclamacaoDaRepublica = [
	{
		city: "Fortaleza",
		city_code: "FOR",
		text:
			"É possível viajar barato para Fortaleza no feriado prolongado da Proclamação da República.",
		img: "FOR"
	},
	{
		city: "São Paulo",
		city_code: "SAO",
		text: "Encontre voos baratos para São Paulo no feriadão da Proclamação da República 2018.",
		img: "SAO"
	},
	{
		city: "Salvador",
		city_code: "SSA",
		text: "Veja passagens aéreas em promoção e curta o feriado da Proclamação em Salvador.",
		img: "SSA"
	},
	{
		city: "Recife",
		city_code: "REC",
		text: "Faça uma viagem econômica para Recife no feriado da Independência do Brasil 2018.",
		img: "REC"
	},
	{
		city: "Curitiba",
		city_code: "CWB",
		text: "Encontre passagens aéreas promocionais para Curitiba no feriadão.",
		img: "CWB"
	},
	{
		city: "Goiânia",
		city_code: "GYN",
		text: "Voos para Goiânia com desconto para você curtir o feriado da Proclamação da República.",
		img: "GYN"
	},
	{
		city: "São Luiz",
		city_code: "SLZ",
		text: "Aproveite o feriado prolongado da Proclamação e viaje para São Luiz com desconto.",
		img: "SLZ"
	},
	{
		city: "Florianópolis",
		city_code: "FLN",
		text: "Saiba o que fazer no feriado prolongado em Florianópolis e veja voos baratos.",
		img: "FLN"
	},
	{
		city: "Porto Alegre",
		city_code: "POA",
		text: "Viaje no feriado da Proclamação da República para Porto Alegre com desconto.",
		img: "POA"
	}
];
export const holidaySemanaSanta = [
	{
		city: "Natal",
		city_code: "NAT",
		text: "Encontre passagens baratas e curta a programação da Semana Santa em Natal. ",
		img: "NAT"
	},
	{
		city: "Gramado",
		city_code: "POA",
		text: "Veja voos baratos para Porto Alegre e aproveite a Semana Santa em Gramado. ",
		img: "GR"
	},
	{
		city: "Ouro Preto",
		city_code: "BHZ",
		text: "Viaje para Belo Horizonte com passagens aéreas promocionais e visite Ouro Preto. ",
		img: "OP"
	},
	{
		city: "Belo Horizonte",
		city_code: "BHZ",
		text: "Voos baratos para Belo Horizonte é o que você precisa para conhecer cidades históricas.",
		img: "BHZ"
	},
	{
		city: "Salvador",
		city_code: "SSA",
		text: "A Semana Santa em Salvador traz uma programação imperdível. Veja voos baratos. ",
		img: "SSA"
	},
	{
		city: "Recife",
		city_code: "REC",
		text: "Viaje para Recife na Semana Santa com economia. Encontre voos promocionais aqui. ",
		img: "REC"
	},
	{
		city: "Caldas Novas",
		city_code: "GYN",
		text: "Aproveite voos baratos para Goiânia e conheça Caldas Novas na Semana Santa. ",
		img: "CA"
	},
	{
		city: "Goiânia",
		city_code: "GYN",
		text: "Encontre voos baratos para Goiânia no período da Semana Santa. ",
		img: "GYN"
	},
	{
		city: "São Paulo",
		city_code: "SAO",
		text: "Passagens promocionais para São Paulo na Semana Santa é aqui. ",
		img: "SAO"
	}
];
export const holidayCorpusChristi = [
	{
		city: "São Paulo",
		city_code: "SAO",
		text: "Voe para São Paulo no Corpus Christi e inicie uma viagem de fé e espiritualidade.",
		img: "SAO"
	},
	{
		city: "Brasília",
		city_code: "BSB",
		text: "Passagens aéreas promocionais para Brasília no feriado de Corpus Christi é aqui.",
		img: "BSB"
	},
	{
		city: "Rio de Janeiro",
		city_code: "RIO",
		text: "Encontre voos baratos para passar o Corpus Christi no Rio de Janeiro.",
		img: "RIO"
	},
	{
		city: "Fortaleza",
		city_code: "FOR",
		text: "Curta Fortaleza no Corpus Christi, economizando nas passagens aéreas.",
		img: "FOR"
	},
	{
		city: "Porto Alegre",
		city_code: "POA",
		text: "Imperdível é passar o Corpus Christi em Porto Alegre com passagem aérea promocional.",
		img: "POA"
	},
	{
		city: "Salvador",
		city_code: "SSA",
		text: "Viaje para Recife na Semana Santa com economia. Encontre voos promocionais aqui. ",
		img: "SSA"
	},
	{
		city: "Recife",
		city_code: "REC",
		text: "Compre passagens aéreas com desconto para passar o Corpus Christi em Recife.",
		img: "REC"
	},
	{
		city: "Belo Horizonte",
		city_code: "BHZ",
		text: "Aproveite a religiosidade mineira viajando para Belo Horizonte no Corpus Christi.",
		img: "BHZ"
	},
	{
		city: "Goiânia",
		city_code: "GYN",
		text: "Corpus Christi em Goiânia é uma boa pedida para quem gosta da tradição do cerrado.",
		img: "GYN"
	}
];
export const holidayFinados = [
	{
		city: "Recife",
		city_code: "REC",
		text: "Voe para Recife com passagens aéreas promocionais no feriado de Finados.",
		img: "REC"
	},
	{
		city: "Rio de Janeiro",
		city_code: "RIO",
		text: "Compre passagens aéreas com desconto e passe o feriado no Rio de Janeiro.",
		img: "RIO"
	},
	{
		city: "São Paulo",
		city_code: "SAO",
		text: "Quer passar o feriado de Finados em São Paulo? Aproveite nossas passagens.",
		img: "SAO"
	},
	{
		city: "Brasília",
		city_code: "BSB",
		text: "Passagens aéreas promocionais para Brasília no feriado de Finados é aqui.",
		img: "BSB"
	},
	{
		city: "Belo Horizonte",
		city_code: "BHZ",
		text: "Encontre voos baratos para passar o feriado de Finados em Belo Horizonte.",
		img: "BHZ"
	},
	{
		city: "Porto Alegre",
		city_code: "POA",
		text: "Viaje no feriado de Finados para Porto Alegre com passagens aéreas promocionais.",
		img: "POA"
	},
	{
		city: "Fortaleza",
		city_code: "FOR",
		text: "Passe o feriado de Finados em Fortaleza, economizando nas passagens aéreas.",
		img: "FOR"
	},
	{
		city: "Salvador",
		city_code: "SSA",
		text: "Pensou em um lugar especial para passar o feriado de Finados? Voe para Salvador.",
		img: "SSA"
	},
	{
		city: "Manaus",
		city_code: "MAO",
		text: "Economize no feriado de Finados aproveitando passagens aéreas baratas para Manaus.",
		img: "MAO"
	}
];
